import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import teamChartEmptyState2x from './images/teamChartEmptyState2x.png'
import teamChartEmptyState from './images/teamChartEmptyState.png'
import './index.styles.css'
type Props = {
  canEdit: boolean
  loading?: boolean
  onStart: () => void
}

const EmptyState: React.FC<Props> = ({ canEdit, loading, onStart }: Props) => {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="s80"
      flexGrow
      padding="s24"
    >
      <Box padding="s12" className={'EmptyState_imageContainer'}>
        <img
          src={teamChartEmptyState}
          srcSet={`${teamChartEmptyState2x} 2x`}
          className={'EmptyState_image'}
        ></img>
      </Box>
      <Box gap="s32" alignItems="center">
        <Box gap="s12" alignItems="center">
          {canEdit && (
            <Text.Header2 color="grey1000" weight="semibold">
              {i18n.t('people_chart.empty_state.start_crafting')}
            </Text.Header2>
          )}
          <Text.Normal size="300" weight="medium" color="grey800">
            {i18n.t('people_chart.empty_state.description')}
          </Text.Normal>
        </Box>{' '}
        {canEdit && (
          <Button iconName="arrow-right" onClick={onStart} loading={loading}>
            {i18n.t('people_chart.empty_state.start')}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default EmptyState
